import { createContext } from "react"
import { Interface } from "../interfaces/Interface"
import LandingViewContent from "../interfaces/LandingViewContent"

const LandingViewContext = createContext<LandingViewContent>(Interface.emptyInterface<LandingViewContent>());

export default LandingViewContext;
